module.exports = __webpack_public_path__ + "static/media/muted-bell.3d6e279a.svg";